var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    staticClass: "board-table board-table--inquiry",
    attrs: {
      "role": "table"
    }
  }, [_vm._m(0), _vm._l(_vm.applications, function (application, index) {
    var _application$program;
    return _c('div', {
      key: application._id,
      attrs: {
        "role": "rowgroup"
      }
    }, [_c('router-link', {
      attrs: {
        "role": "row",
        "to": _vm.getTo(application)
      }
    }, [_c('div', {
      staticClass: "num",
      attrs: {
        "role": "cell"
      }
    }, [_vm._v(_vm._s((_vm.page - 1) * _vm.limit + index + 1))]), _c('div', {
      staticClass: "title",
      attrs: {
        "role": "cell"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s((application === null || application === void 0 ? void 0 : (_application$program = application.program) === null || _application$program === void 0 ? void 0 : _application$program.title) || '삭제된 프로그램입니다'))])]), _c('div', {
      staticClass: "cell date",
      attrs: {
        "role": "cell"
      }
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(application.createdAt.toDate()))])])])], 1);
  })], 2), _c('pagination-component', {
    attrs: {
      "count": _vm.pageCount
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "num",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("번호")]), _c('div', {
    staticClass: "title",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("서비스명")]), _c('div', {
    staticClass: "cell",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("신청일")])])]);
}]

export { render, staticRenderFns }